<template>
  <div class="globalSettins_page">
    <TextTable
      :all_data = "all_data"
    />
  </div>
</template>

<script>
import TextTable from 'components/UIComponents/Plugins/TextTablePlagin/TextTable.vue';

export default {
  name: 'ProxyServers',
  components: {
    TextTable
  },
  data () {
    return {
      all_data: {}
    }
  },
  mounted () {
    this.$http.v1.getProxyServers((response) => {
      this.all_data = response.data
    })
  }
}
</script>

<style lang="scss" scoped>
  .globalSettins_page{
    height: 100%;
  }
  @media (max-width: 1300px){
    .response_table{
      font-size: 12px;
    }
  }
</style>
